import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AppLayout } from "../../components/layout/Header";
import TextInput from "../../components/forms/TextInput";
import { useAuth } from "../../js/hooks/useAuth";
import { validateLogin } from "../../js/utils/validators";
import { resolvePostAuthPath } from "../../js/auth/onboardingState";
import { toTitleCase } from "../../js/utils/titleCase";
import LifecycleLoginNote from "../../components/account/LifecycleLoginNote";
import { REPTC_POWERED } from "../../js/utils/reptc";
export default function RoleLogin({
  role,
  title,
  lead,
  defaultEmail,
  successPath,
  variant = "public",
  links = [],
  newHereTo,
}) {
  const navigate = useNavigate();
  const otherLinks = links.filter((link) => !/register|create/i.test(`${link.to} ${link.label}`));
  const { login } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const [lifeError, setLifeError] = useState(null);

  function update(event) {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  }

  async function handleSubmit(event) {
    event.preventDefault();
    const nextErrors = validateLogin(form);
    setErrors(nextErrors);
    if (Object.keys(nextErrors).length) return;
    try {
      setLifeError(null);
      const session = await login(form, role);
      navigate(resolvePostAuthPath(session, role));
    } catch (error) {
      setMessage(error.message);
      setLifeError(error);
    }
  }

  return (
    <AppLayout variant={variant}>
      <div className="card auth-card" data-tour="auth-card">
        <h1>{toTitleCase(title)}</h1>
        <p className="page-lead">{lead}</p>
        <form onSubmit={handleSubmit} autoComplete="off">
          <div className="auth-signin-row">
            <TextInput
              label="Email"
              name="email"
              type="email"
              value={form.email}
              onChange={update}
              error={errors.email}
              autoComplete="username"
            />
            <TextInput
              label="Password"
              name="password"
              type="password"
              value={form.password}
              onChange={update}
              error={errors.password}
              autoComplete="current-password"
            />
          </div>
          {message ? <p className="field-error">{message}</p> : null}
          {role === "agent" || role === "broker" ? (
            <LifecycleLoginNote
              error={lifeError}
              form={form}
              onReactivated={() => handleSubmit({ preventDefault() {} })}
            />
          ) : null}
          <button type="submit" className="primary-btn btn-block">
            Sign in
          </button>
        </form>
        <p className="auth-switch muted">
          <Link to="/forgot-password">Forgot password?</Link>
        </p>
        <p className="auth-switch muted">
          <Link to={newHereTo || `/register?role=${role}`}>New Here?</Link>
        </p>
        {otherLinks.length ? (
          <p className="muted">
            {otherLinks.map((link, index) => (
              <span key={link.to}>
                {index > 0 ? " · " : null}
                <Link to={link.to}>{link.label}</Link>
              </span>
            ))}
          </p>
        ) : null}
        {role === "agent" || role === "broker" ? (
          <p className="reptc-powered">{REPTC_POWERED}</p>
        ) : null}
      </div>
    </AppLayout>
  );
}
